export default __webpack_public_path__ + "static/media/Sun Health_Dental.53038ef8.jpg";